import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Radio.scss";

export const Radio = ({
  value = false,
  onChange,
  label = "",
  name = "",
  className,
}) => {
  const handleChange = (e) => {
    if (e.target.checked && onChange) {
      onChange(true);
    }
  };

  return (
    <div className={classNames("radio-container", className)}>
      <label className="container">
        <input
          type="radio"
          name={name}
          checked={value}
          onChange={handleChange}
        />
        <span className="radiomark"></span>
        {label && <span className="radio-label">{label}</span>}
      </label>
    </div>
  );
};

Radio.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
};

export default Radio;

